"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var classNames = require("classnames");

var GeneralHours = /*#__PURE__*/function (_Component) {
  _inherits(GeneralHours, _Component);

  var _super = _createSuper(GeneralHours);

  function GeneralHours(props) {
    var _this;

    _classCallCheck(this, GeneralHours);

    _this = _super.call(this, props);
    _this.state = {
      dateLines: []
    };
    return _this;
  }

  _createClass(GeneralHours, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.sortDays(this.props.locationHours);
    }
  }, {
    key: "sortDays",
    value: function sortDays(arr) {
      if (!arr) throw "No array of days to sort, " + arr + " was received.";

      var groupBy = function groupBy(items, key) {
        return items.reduce(function (result, item) {
          return _objectSpread({}, result, _defineProperty({}, item[key], [].concat(_toConsumableArray(result[item[key]] || []), [item])));
        }, {});
      };

      var newArr = [];

      for (var i = 0; i < arr.length; i++) {
        var _obj = arr[i];
        _obj.combinedTime = "".concat(_obj.startTime, "\u2013").concat(_obj.endTime);
        _obj.shortWeekDay = whatShortWeekDay(_obj.weekDay, this.props.language);
        _obj.fullWeekDAy = whatWeekDay(_obj.weekDay, this.props.language);
        newArr.push(_obj);
      }

      var sortedDates = groupBy(newArr, "combinedTime");

      for (var _i = 0; _i < sortedDates.length; _i++) {
        sortedDates[_i].sort(function (a, b) {
          return a.weekDay > b.weekDay ? 1 : -1;
        });
      }

      var dayLineArr = [];
      var combinedTimeObjs = [];

      for (var key in sortedDates) {
        var obj = sortedDates[key];
        var tempArr = [];
        var tempArrFullObj = [];

        for (var _i2 = 0; _i2 < obj.length; _i2++) {
          tempArr.push({
            shortWeekDay: obj[_i2].shortWeekDay,
            weekDay: obj[_i2].weekDay
          });
          tempArrFullObj.push(obj[_i2]);
        }

        dayLineArr.push(tempArr);
        combinedTimeObjs.push(tempArrFullObj);
        tempArr = [];
        tempArrFullObj = [];
      }

      var dayLineDays = [];
      var dayLineTimes = [];

      function nonConsecutiveDays() {
        if (allDaysAreConsecutive(dayLineArr)) {
          for (var _i3 = 0; _i3 < dayLineArr.length; _i3++) {
            dayLineDays.push(joinWithDash(dayLineArr[_i3]));
            var tempDayTimes = combinedTimeObjs[_i3][0].combinedTime;
            dayLineTimes.push(tempDayTimes);
          }
        } else {
          for (var _i4 = 0; _i4 < dayLineArr.length; _i4++) {
            if (dayLineArr[_i4].length === 1) {
              dayLineDays.push(dayLineArr[_i4][0].shortWeekDay + ": ");
            } else if (daysInLineAreConsecutive(dayLineArr[_i4])) {
              dayLineDays.push(joinWithDash(dayLineArr[_i4]));
            } else {
              dayLineDays.push(joinWithCommas(dayLineArr[_i4]));
            }

            var _tempDayTimes = combinedTimeObjs[_i4][0].combinedTime;
            dayLineTimes.push(_tempDayTimes);
          }
        }

        var finalDateLines = [];

        for (var _i5 = 0; _i5 < dayLineDays.length; _i5++) {
          var _obj2 = {};
          _obj2.days = dayLineDays[_i5];
          _obj2.times = dayLineTimes[_i5];
          finalDateLines.push(_obj2);
        }

        return finalDateLines;
      } // Only one array of days


      function allDaysAreConsecutive(days) {
        if (days.length === 1) {
          return true;
        }

        return false;
      } // Join length of consecutive days with dash


      function joinWithDash(dayLineArr) {
        var tempDayLine = dayLineArr[0].shortWeekDay + "–" + dayLineArr[dayLineArr.length - 1].shortWeekDay;
        tempDayLine += ": ";
        return tempDayLine;
      } // Join non-all consecutive days with dash


      function joinWithCommas(dayLineArr) {
        var tempDayLine = [];

        for (var j = 0; j < dayLineArr.length; j++) {
          tempDayLine.push(dayLineArr[j].shortWeekDay);
        }

        tempDayLine = tempDayLine.join(", ");
        tempDayLine += ": ";
        return tempDayLine;
      } // Check if every day - 1 is equal to the day before


      function daysInLineAreConsecutive(daysObj) {
        var consecutive = true;

        for (var j = 1; j < daysObj.length; j++) {
          if (parseInt(daysObj[j - 1].weekDay) + 1 !== parseInt(daysObj[j].weekDay)) {
            consecutive = false;
          }
        }

        return consecutive;
      } // One-off for Mon-Fri, needs to be re-worked


      function allConsecutiveDays() {
        var startDay = combinedTimeObjs[0][0];
        var endDay = combinedTimeObjs[0][0];

        for (var _i6 = 0; _i6 < combinedTimeObjs[0].length - 1; _i6++) {
          if (parseInt(combinedTimeObjs[0][_i6 + 1].weekDay) === parseInt(endDay.weekDay) + 1) {
            endDay = combinedTimeObjs[0][_i6 + 1];
          }
        }

        var tempDayLine = startDay.shortWeekDay + "–" + endDay.shortWeekDay + ": ";
        var tempDayTimes = combinedTimeObjs[0][0].combinedTime;
        dayLineDays.push(tempDayLine);
        dayLineTimes.push(tempDayTimes);
        var finalDateLines = [];
        var obj = {};
        obj.days = dayLineDays[0];
        obj.times = dayLineTimes[0];
        finalDateLines.push(obj);
        return finalDateLines;
      } // allConsecutiveDays();


      var finalDateLines = nonConsecutiveDays(); // let finalDateLines = allConsecutiveDays()

      function linkConsecutiveDays(days) {}

      this.setState({
        dateLines: finalDateLines
      });

      function whatWeekDay(date, language) {
        var day = date;

        if (language && language === "es") {
          switch (day) {
            case "0":
              day = "Domingo";
              return day;

            case "1":
              day = "Lunes";
              return day;

            case "2":
              day = "Martes";
              return day;

            case "3":
              day = "Miércoles";
              return day;

            case "4":
              day = "Jueves";
              return day;

            case "5":
              day = "Viernes";
              return day;

            case "6":
              day = "Sábado";
              return day;
          }
        }

        switch (day) {
          case "0":
            day = "Sunday";
            return day;

          case "1":
            day = "Monday";
            return day;

          case "2":
            day = "Tuesday";
            return day;

          case "3":
            day = "Wednesday";
            return day;

          case "4":
            day = "Thursday";
            return day;

          case "5":
            day = "Friday";
            return day;

          case "6":
            day = "Saturday";
            return day;
        }
      }

      function whatShortWeekDay(date, language) {
        var day = date;

        if (language && language === "es") {
          switch (day) {
            case "0":
              day = "Do";
              return day;

            case "1":
              day = "Lu";
              return day;

            case "2":
              day = "Ma";
              return day;

            case "3":
              day = "Mi";
              return day;

            case "4":
              day = "Ju";
              return day;

            case "5":
              day = "Vi";
              return day;

            case "6":
              day = "Sa";
              return day;
          }
        }

        switch (day) {
          case "0":
            day = "Sun";
            return day;

          case "1":
            day = "Mon";
            return day;

          case "2":
            day = "Tues";
            return day;

          case "3":
            day = "Wed";
            return day;

          case "4":
            day = "Thur";
            return day;

          case "5":
            day = "Fri";
            return day;

          case "6":
            day = "Sat";
            return day;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var dateLines = this.state.dateLines.map(function (line, i) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, line.times === "–" ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: Math.floor(Math.random() * 100) + i
        }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: Math.floor(Math.random() * 100) + i
        }, line.days, /*#__PURE__*/_react["default"].createElement("span", {
          className: "no-word-break"
        }, line.times), /*#__PURE__*/_react["default"].createElement("br", null)));
      });
      var wrapperClass = classNames("btn", this.props.className, {
        column: true,
        "footer-hours": this.props.footer,
        "contact-sidebar-block": this.props.contact
      });
      var paragraphClassName = classNames({
        small: this.props.footer,
        "contact-hours": this.props.contact
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: wrapperClass
      }, this.props.footer && /*#__PURE__*/_react["default"].createElement("div", {
        className: "column"
      }, /*#__PURE__*/_react["default"].createElement("h7", null, this.props.language === "es" ? "Horas" : "Hours")), this.props.contact && /*#__PURE__*/_react["default"].createElement("h7", null, this.props.language === "es" ? "Horas" : "Hours"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "column"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: paragraphClassName
      }, dateLines)));
    }
  }]);

  return GeneralHours;
}(_react.Component);

var requiredPropsCheck = function requiredPropsCheck(props, propName, componentName) {
  if (!props.footer && !props.contact) {
    return new Error("One of 'footer' or 'contact' is required by '".concat(componentName, "' component."));
  }

  if (props.footer && typeof props.footer !== "boolean") {
    return new Error("'footer' is not a boolean");
  }

  if (props.contact && typeof props.contact !== "boolean") {
    return new Error("'contact' is not a boolean");
  }
};

GeneralHours.propTypes = {
  footer: requiredPropsCheck,
  contact: requiredPropsCheck,
  className: _propTypes["default"].string,
  locationHours: _propTypes["default"].array.isRequired,
  language: _propTypes["default"].string
};
var _default = GeneralHours;
exports["default"] = _default;

//# sourceMappingURL=GeneralHours.js.map